import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import {
  schemasFetchAllFailureAction
, schemasFetchAllRequestAction
, schemasFetchAllSuccessAction
, schemasFetchOneFailureAction
, schemasFetchOneRequestAction
, schemasFetchOneSuccessAction
, setSelectedSchemaName
} from './schemasActions';
import { SchemaModel } from '../../models/schemaModel';
import { SchemasStateModel } from './schemasStateModel';

export const schemasAdapter = createEntityAdapter<SchemaModel>({selectId: (e) => e.name});

const initialState: SchemasStateModel = schemasAdapter.getInitialState({
  loading: false,
  errors: [],
});

export const schemasReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setSelectedSchemaName, (state, action) => {
      state.selectedSchemaName = action.payload;
    })

    .addCase(schemasFetchAllRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(schemasFetchAllSuccessAction, (state, action) => {
      state.loading = false;
      schemasAdapter.setAll(state, action.payload);
    })
    .addCase(schemasFetchAllFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    })

    .addCase(schemasFetchOneRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(schemasFetchOneSuccessAction, (state, action) => {
      state.loading = false;
      schemasAdapter.upsertOne(state, action.payload);
    })
    .addCase(schemasFetchOneFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    });
});
